<template>
  <div>

    <form
      role="form"
      class="card bg-secondary p-3 contact-form"
      id="contact-form"
      v-if="!emailSent"
      @submit.prevent="sendEmail"
    >
      <div class="card-body">

              <div class="row">

           
          <div class="col-md-6">
            <div class="form-group">
              <label>First name</label>
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"
                    ><i class="ni ni-circle-08"></i
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  name="first_name"
                  placeholder="First Name..."
                  aria-label="First Name..."
                  v-model="firstName"
                />
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-group">
              <label>Last name</label>
              <div class="input-group input-group-alternative">
                <div class="input-group-prepend">
                  <span class="input-group-text"
                    ><i class="ni ni-tag"></i
                  ></span>
                </div>
                <input
                  type="text"
                  class="form-control"
                  name="last_name"
                  placeholder="Last Name..."
                  aria-label="Last Name..."
                                 v-model="lastName"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label>Email address</label>
          <div class="input-group input-group-alternative">
            <div class="input-group-prepend">
              <span class="input-group-text"
                ><i class="ni ni-email-83"></i
              ></span>
            </div>
            <input
              type="email"
              name="user_email"
              class="form-control"
              placeholder="Email Here..."
                             v-model="email"
            />
          </div>
        </div>
        <div class="form-group">
          <label>Your message</label>
          <textarea
            name="message"
            class="form-control form-control-alternative"
            id="message"
            rows="6"
          ></textarea>
        </div>
        <div class="row">
          <div class="col-md-6 ml-auto">
            <button type="submit" class="btn btn-primary pull-right">
              Send Message
            </button>
          </div>
        </div>
      </div>
    </form>

    <div v-if="emailSent">
      <p class="lead h2 card p-2 text-center">Thank you for contacting us, we will get back to you soon.</p>
    </div>
  </div>
</template>

<script>
import emailjs from "emailjs-com";

export default {
  name: "EmailForm",
  data() {
    return {
         emailSent: false ,
         email :'',
         firstName:'',
         lastName:''
    };
  },
  methods: {
    sendEmail: function (e) {
      const self = this;


     emailjs
        .sendForm(
          "Universaltech.it.2020",
          "unitechtemplate2",
          e.target,
          "user_788f1NCUIibxUinY5Wscw"
        )
        .then(
          (result) => {
            console.log("SUCCESS!", result.status, result.text);
            self.emailSent = true;
            setTimeout( () =>{
                self.emailSent = false;
                self.email = '';
                self.firstName = '';
                self.lastName  = '';
                } , 5000);
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );
        
    },
  },
};
</script>
